import {
  BooleanPropertyDefinition,
  StringPropertyDefinition
} from '@shared/models/schema-property-definition';
import {
  IdObjectValue
} from '@shared/models/schema-property-definition/id-value/id-object-value';

export namespace Dependent {
  export interface SchemaPropertyDefinition {
    birthDate: StringPropertyDefinition;
    financiallyDependent: BooleanPropertyDefinition;
    name: StringPropertyDefinition;
    otherGuardian: StringPropertyDefinition;
  }

  export type CollectionSchemaContract = IdObjectValue.SchemaContractCollection<{
    birthDate?: string | null;
    financiallyDependent?: boolean;
    name: string;
    otherGuardian?: string | null;
  }>;

  export interface Model extends IdObjectValue.Crud.Updatable {
    birthDate?: string | null;
    financiallyDependent: boolean;
    name: string;
    otherGuardian?: string | null;
  }

  export function toModel(values: CollectionSchemaContract): Model[] {
    return IdObjectValue.Crud.toNativeArray(values, (x) => ({
      created: false,
      deleted: x.deleted,
      id: x.id,
      name: x.name,
      otherGuardian: x.otherGuardian,
      birthDate: x.birthDate,
      financiallyDependent: x.financiallyDependent ?? false
    }));
  }

  export function toCollectionSchemaContracts(
    values: Model[]
  ): CollectionSchemaContract {
    return IdObjectValue.Crud.toIdObjectValueSchemaCollection(values);
  }
}
